import { Button, DatePicker, LoadingButton } from "components/form";
import { getFromLocal } from "config/axiosInstance";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { createSurveyApi } from "services/survey";
import { isTrue } from "utils/commonHelper";
import { toDate } from "utils/dateHelper";
import { toastMessage } from "utils/toastMessageHelper";
import { validateInput } from "validation";
import { survey } from "validation/schema/survey";

const ExtendSurveyDate = ({
  isUpdate,
  surveyId,
  setIsUpdate,
  handleClose,
  isListUpdated,
  setSurveyList,
  setSelectedSurveyDetail,
  mySurveyListUpdated,
  selectedSurveyDetail,
}) => {
  const [inputData, setInputDate] = useState({ expiryDate: "" });
  const [error, setError] = useState({});
  const [buttonLoader, setButtonLoader] = useState(false);

  // hooks handler
  const { t } = useTranslation();

  //   Function handler
  //  Close survey model handler
  const closeSurveyModel = () => {
    setInputDate("");
    handleClose();
  };

  // Input Validation function
  const validation = () => {
    const { errors, status } = validateInput(
      inputData,
      "extendExpiryDateSchema",
      survey,
      null
    );
    setError(errors);
    return status;
  };

  //   Change Expiry Date handler
  const changeExpiryDateHandler = (date) => {
    setError("");
    setInputDate({ expiryDate: toDate(date) });
  };

  //   Extend Expire date handler
  const extendExpireDateHandler = async (file) => {
    if (validation()) {
      try {
        setButtonLoader(true);
        const reqData = {
          surveyId: surveyId,
          token: getFromLocal() || "",
          expiryDate: toDate(inputData?.expiryDate),
        };
        const responseData = await createSurveyApi(reqData);
        const { message = "", status } = responseData;
        if (status === 200) {
          toastMessage(message, "success", "extendExpirySurveyDate");
          if (isTrue(isListUpdated)) {
            setSurveyList((prev) =>
              prev.map((item) => {
                if (item?._id === reqData?.surveyId) {
                  return { ...item, expiryDate: reqData?.expiryDate };
                }
                return item;
              })
            );
          } else {
            setSelectedSurveyDetail((prev) => ({
              ...prev,
              expiryDate: reqData?.expiryDate
                ? reqData?.expiryDate
                : prev.expiryDate,
            }));
          }
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setButtonLoader(false);
        closeSurveyModel();
      }
    }
  };

  return (
    <div>
      <h3>{t("EXPIRYDATE.editExpiryDate")}</h3>
      <p>{t("EXPIRYDATE.sureEditExpiryDate")}</p>
      <div className="form_field">
        <DatePicker
          name="dob"
          label={t("EXPIRYDATE.expiryDate")}
          minDate={new Date()}
          error={error?.expiryDate}
          value={inputData?.expiryDate || ""}
          placeholder={t("EXPIRYDATE.enterExpiryDate")}
          onChange={(date) => changeExpiryDateHandler(date)}
        />
      </div>
      <div className="button_wrap">
        <LoadingButton
          className="light"
          loading={buttonLoader}
          onClick={extendExpireDateHandler}
        >
          {t("EXPIRYDATE.edit")}
        </LoadingButton>
        <Button onClick={closeSurveyModel}>{t("EXPIRYDATE.cancel")}</Button>
      </div>
    </div>
  );
};

export default ExtendSurveyDate;
